/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_standings_how_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How F1 Standings work`)
};

const es_f1_standings_how_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo funciona la clasificación de F1`)
};

const de_f1_standings_how_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie die F1-Wertung funktioniert`)
};

const nl_f1_standings_how_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe de F1-stand werkt`)
};

const fr_f1_standings_how_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment fonctionne le classement F1`)
};

const it_f1_standings_how_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come funziona la classifica F1`)
};

const pt_br2_f1_standings_how_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como funciona a classificação da F1`)
};

const pt_f1_standings_how_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como funciona a classificação da F1`)
};

const ja_f1_standings_how_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1順位表の仕組み`)
};

const zh_f1_standings_how_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1积分榜如何运作`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_standings_how_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_standings_how_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_standings_how_title", locale)
	if (locale === "en") return en_f1_standings_how_title(inputs)
	if (locale === "es") return es_f1_standings_how_title(inputs)
	if (locale === "de") return de_f1_standings_how_title(inputs)
	if (locale === "nl") return nl_f1_standings_how_title(inputs)
	if (locale === "fr") return fr_f1_standings_how_title(inputs)
	if (locale === "it") return it_f1_standings_how_title(inputs)
	if (locale === "pt-BR") return pt_br2_f1_standings_how_title(inputs)
	if (locale === "pt") return pt_f1_standings_how_title(inputs)
	if (locale === "ja") return ja_f1_standings_how_title(inputs)
	return zh_f1_standings_how_title(inputs)
};